import { render, staticRenderFns } from "./TransitionElements.vue?vue&type=template&id=4979356c&scoped=true"
import script from "./TransitionElements.vue?vue&type=script&lang=js"
export * from "./TransitionElements.vue?vue&type=script&lang=js"
import style0 from "./TransitionElements.vue?vue&type=style&index=0&id=4979356c&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4979356c",
  null
  
)

export default component.exports